import request from '../utils/RequestUtil';

function getPersonalDetail() {
  return request({
    url: '/persona/detalle',
    method: 'POST'
  });
}

// eslint-disable-next-line import/prefer-default-export
export { getPersonalDetail };
